
import React, { useState } from 'react';
import { message, Upload, Form, Select } from 'antd';
import { Link } from 'react-router-dom';
function UploadDocument() {
    const [uploadImage, setUploadImage] = useState();
    const [loading, setLoading] = useState(false);
    const [uploadDone, setUploadDone] = useState(false)
    const { Option } = Select;

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true)
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, imageUrl =>{
                setUploadImage(imageUrl);
                setLoading(false);
                setUploadDone(true)

            }
                
            );
        }
    };

    const RemoveImg=()=>{
        setUploadDone(false)

    }
    return (
        <div className="uploadDocumentImage">
            <Form>
                <div className="uploadHeader">
                    <div className="titleUpload">
                        <h5>Giấy tờ tải lên thông tin khắc nhập</h5>
                        <p>(CMND, Bằng lái xe, Hộ chiếu, Căn cước CD)</p>
                    </div>
                    <Form.Item className="formInput"
                        label="Loại giấy tờ"
                        name="document_type"
                    >
                        <Select placeholder="Chọn loại giấy tờ" >
                            <Option value="CCCD">Căn cước công dân</Option>
                            <Option value="CMND">Chứng minh nhân dân</Option>
                            <Option value="HC">Hộ chiếu</Option>
                            <Option value="BLX">Bằng lái xe</Option>
                        </Select>
                    </Form.Item>
                </div>
                <div className="uploadBody">
                    <div className="uploadForm">
                        {uploadDone ?
                            <div className="removeUpload" onClick={RemoveImg}>
                                <img src="/images/ic_remove.png" alt="" />
                            </div>

                            : null}

                        <Upload
                            name="avatar"
                            listType="picture-card"
                            className="upload"
                            showUploadList={false}
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                            beforeUpload={beforeUpload}
                            onChange={handleChange}
                        >
                            {!uploadDone ?
                                (
                                    <div className="formUpload uploadDefault">
                                        <img className="img-fluid" src="/images/ic_badge.png" alt="" />
                                        <div className="note">
                                            <p ><span>Chọn file</span> hoặc kéo thả ảnh vào đây</p>
                                            <p>(bạn cần upload ảnh mặt trước)</p>
                                        </div>

                                    </div>
                                ) :
                                <div className="formUpload imgUpload">

                                    <img className="img-fluid imgUpload" src={uploadImage} alt="" />
                                    <div className="note">
                                        <p ><span>Chọn file</span> hoặc kéo thả ảnh vào đây</p>
                                    </div>

                                </div>
                            }

                        </Upload>
                    </div>
                    <div className="btnConfirm">
                        <button className="btnStyle">Xác nhận</button>
                    </div>
                </div>
                <div className="uploadFooter">
                    <p>Để hệ thống quét chính xác nhất bận cần:</p>
                    <ul>
                        <li>Chụp ảnh ở góc chính diện</li>
                        <li>Ảnh không bị mờ</li>
                        <li>Ảnh không quá tối và quá sáng</li>
                    </ul>
                </div>
            </Form>
            
        </div>
    );
}
export default UploadDocument;